import { Star, Shield, Zap, Clock } from "lucide-react";
import { testimonials } from "../data/serviceData";
import { useTheme } from "../context/ThemeContext";

const TRUST_POINTS = [
  { icon: Shield, label: "R18M Liability Coverage", desc: "Every job, fully insured." },
  { icon: Zap, label: "Qualified & Vetted Technicians", desc: "Background-checked professionals." },
  { icon: Clock, label: "25-Min Avg ETA", desc: "Urgent calls prioritised." },
  { icon: Star, label: "4.97 Avg Rating", desc: "From 12,000+ verified jobs." },
];

function TestimonialCard({ t, isDark }) {
  return (
    <div className={`flex-shrink-0 w-64 sm:w-72 p-5 rounded-xl border mx-2 ${isDark ? "bg-[#141419] border-[#222226]" : "bg-white border-slate-200 shadow-[var(--shadow-card)]"}`}>
      <div className="flex items-center gap-1 mb-3">
        {Array.from({ length: t.rating }).map((_, i) => (
          <Star key={i} size={12} className="text-yellow-400 fill-yellow-400" />
        ))}
      </div>
      <p className={`text-sm leading-relaxed mb-4 break-words ${isDark ? "text-[#8F9098]" : "text-slate-600"}`}>"{t.text}"</p>
      <div>
        <p className={`text-sm font-semibold ${isDark ? "text-white" : "text-slate-900"}`}>{t.name}</p>
        <p className={`text-xs ${isDark ? "text-[#8F9098]" : "text-slate-500"}`}>{t.role}</p>
      </div>
    </div>
  );
}

export default function Testimonials() {
  const { theme } = useTheme();
  const isDark = theme === "dark";
  const doubled = [...testimonials, ...testimonials];

  return (
    <section id="testimonials" className="py-20 sm:py-24 overflow-hidden">
      <div className="px-6 md:px-12 lg:px-20 mb-16">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <p className={`text-xs uppercase tracking-[0.2em] mb-3 font-mono font-semibold ${isDark ? "text-[#00F0FF]" : "text-brand-teal"}`}>
              Real customers
            </p>
            <h2 className={`font-display font-bold text-4xl lg:text-5xl tracking-tighter mb-4 ${isDark ? "text-white" : "text-slate-900"}`}>
              What They Say
            </h2>
          </div>

          {/* Trust points bento */}
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
            {TRUST_POINTS.map(({ icon: Icon, label, desc }) => (
              <div
                key={label}
                className={`p-5 rounded-xl border hover:-translate-y-0.5 transition-all duration-200 ${
                  isDark
                    ? "bg-[#0C0C0F] border-[#222226] hover:border-[#00F0FF]/30"
                    : "bg-white border-slate-200 shadow-[var(--shadow-card)] hover:border-brand-blue/30 hover:shadow-[var(--shadow-card-hover)]"
                }`}
              >
                <div className={`w-9 h-9 rounded-lg flex items-center justify-center mb-3 ${isDark ? "bg-[#00F0FF]/10" : "bg-brand-teal/10"}`}>
                  <Icon size={16} className={isDark ? "text-[#00F0FF]" : "text-brand-teal"} />
                </div>
                <p className={`font-semibold text-sm mb-0.5 ${isDark ? "text-white" : "text-slate-900"}`}>{label}</p>
                <p className={`text-xs ${isDark ? "text-[#8F9098]" : "text-slate-500"}`}>{desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Marquee */}
      <div className="relative">
        <div className={`absolute left-0 top-0 bottom-0 w-20 z-10 pointer-events-none bg-gradient-to-r ${isDark ? "from-[#050507]" : "from-[#F8FAFC]"} to-transparent`} />
        <div className={`absolute right-0 top-0 bottom-0 w-20 z-10 pointer-events-none bg-gradient-to-l ${isDark ? "from-[#050507]" : "from-[#F8FAFC]"} to-transparent`} />
        <div
          className="flex marquee pl-4"
          style={{ width: "max-content" }}
        >
          {doubled.map((t, i) => (
            <TestimonialCard key={i} t={t} isDark={isDark} />
          ))}
        </div>
      </div>
    </section>
  );
}
